<template>
  <div class="container">
    <footer>
      <div class="content has-text-centered">
        <p>
          <strong>Teste de Personalidade</strong> por
          <a href="https://www.linkedin.com/in/hpgomide/">Henrique Gomide</a> - Universidade Federal de Viçosa. 
					<br>Uma pequena parte do código foi escrito durante o horário de trabalho; a outra durante as madrugadas e férias. Mesmo assim, o código segue a licença <a href="http://opensource.org/licenses/mit-license.php">MIT</a>.
					<br>Disponível no meu <a href="https://github.com/henriquepgomide/personality-big-five-ipip100">Github</a>.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.container {
  padding-top: 2em;
}
</style>
